const getFirstLastDateSession = (sessions = []) => {
    let dates = [];

    if (!Array.isArray(sessions) || sessions.length === 0) {
        return dates;
    }

    function compareDate(a, b) {
        return (a.date > b.date);
    }

    let sorted = sessions.sort(compareDate);

    // Copy the array (not a reference) => mandatory because we call shift() and that the render() function may be called more than once...
    let copySorted = sorted.slice(0);

    if (sorted.length === 1) {
        dates = [copySorted.shift()];
    } else {
        let last = copySorted[sorted.length - 1];
        let first = copySorted.shift();

        dates = [first, last];
    }

    return dates;
};

const truncateText = (str, length, ending) => {
    if (length == null) {
        length = 100;
    }
    if (ending == null) {
        ending = '...';
    }
    if (str.length > length) {
        return str.substring(0, length - ending.length) + ending;
    } else {
        return str;
    }
};

export {getFirstLastDateSession, truncateText};


// WEBPACK FOOTER //
// ./src/features/Events/helpers.js